<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Lista de Galerías</h1>
    <div class="results" v-if="galleries">
      <div class="results__element" v-for="(gallery, index) in galleries" :key="index">
        <div class="results__info">
          <h2 class="results__title" v-text="gallery.name"></h2>
          <p v-if="gallery.group_id" class="results__text" v-text="gallery.group_name"></p>
        </div>
        <div class="results__actions">
          <router-link :to="{name: 'galleryImagesView', params: {id: gallery.id}}" class="btn btn__icon btn__icon--regular results__btn results__btn--list">Imagágenes de Galería</router-link>
          <button @click.prevent="$parent.$emit('view', gallery.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--view">Ver Galería</button>
          <button @click.prevent="$parent.$emit('edit', gallery.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--edit">Editar Galería</button>
          <button @click.prevent="deleteGallery(gallery.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--delete">Borrar Galería</button>
        </div>
      </div>
    </div>
    <div class="information" v-else>
      <p class="information__text">No se encontraron resultados</p>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import confirmation from '@/components/layout/confirmation'
export default {
  props: {
    filters: {
      type: String,
      required: false,
      default: function () {
        return ''
      }
    }
  },
  mixins: [
    httpService
  ],
  components: {confirmation},
  data: function () {
    return {
      galleryId: null,
      galleries: null,
      confirm: false
    }
  },
  created: function () {
    this.getGalleries()
  },
  mounted: function () {
    this.$on('continue', () => {
      this.confirm = false
      this.proccedToDelete()
    })
  },
  watch: {
    filters: function () {
      this.getGalleries()
    },
    '$store.state.elementChanged': function () {
      this.getGalleries()
    }
  },
  methods: {
    getGalleries: function () {
      let httpRequest = {
        params: '?' + this.filters,
        module: 'galleries'
      }
      this.get(httpRequest)
        .then(
          galleries => {
            this.galleries = galleries.data
          }
        ).catch(
          () => {
            this.galleries = null
          }
        )
    },
    deleteGallery: function (id) {
      this.confirm = true
      this.galleryId = id
    },
    proccedToDelete: function () {
      let httpRequest = {
        params: '',
        module: 'galleries'
      }
      this.delete(this.galleryId, httpRequest)
        .then(
          response => {
            this.getGalleries()
            this.$store.commit('notificate', {
              title: 'GALERÍA BORRADA',
              text: 'La galería ha sido borrada correctamente',
              type: 'success'
            })
          }
        ).catch (
          error => {
            this.$store.commit('notificate', {
              title: 'GALERÍA NO BORRADA',
              text: 'No se pudo borrar la galería seleccionada, por favor intente más tarde',
              type: 'warn'
            })
          }
        )
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/galleries/list.vue